module.exports = {
  email: 'https://www.linkedin.com/in/satenderrathore',

  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/SatenderRathore',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/satenderrathore',
    },
    {
      name: 'X',
      url: 'https://x.com/Ra_ThoreSA',
    },
    {
      name: 'Medium',
      url: 'https://medium.com/@satendersinghrathore',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Projects',
      url: '/#projects',
    },
  ],

  colors: {
    green: '#5eead4',
    navy: '#0f172a',
    darkNavy: '#020617',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
